/**
 * 숫자를 세 자리마다 콤마(`,`)로 구분하여 문자열로 변환합니다.
 *
 * 숫자 외의 값이 입력된 경우 에러를 발생시킵니다.
 *
 * @param value - 포맷할 숫자
 * @returns 세 자리마다 콤마로 구분된 문자열
 * @throws `Error` - 입력값이 숫자 타입이 아닐 경우 발생합니다.
 *
 * @example
 * ```ts
 * formatNumberWithComma(1234567); // '1,234,567'
 * formatNumberWithComma(9876543210); // '9,876,543,210'
 * ```
 */
export const formatNumberWithComma = (value: number): string => {
  // js 환경에서의 사용을 고려한 예외처리
  if (typeof value !== 'number') {
    throw new Error(`formatNumberWithComma: number타입이 아닌 값 - ${value}`);
  }

  const formattedNumber = value.toLocaleString();

  return formattedNumber;
};
